import React from 'react';

export default function HeroVideo() {
  const scrollToContact = () => {
    const el = document.getElementById('kontakt');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section id="home" className="w-full">
      <div className="relative pb-[100%] md:pb-[65%] lg:pb-0 w-full lg:h-screen overflow-hidden">
        <video
          className="absolute inset-0 w-full h-full object-cover"
          poster="/assets/handshake-poster.jpg"
          autoPlay
          loop
          muted
          playsInline
        >
          <source src="/assets/handshake.mp4" type="video/mp4" />
          Váš prohlížeč nepodporuje přehrávání videa.
        </video>

        <div className="absolute inset-0 bg-black/40" />

        <div className="z-10 absolute inset-0 flex flex-col justify-center items-center px-4 text-white text-center">
          <h1 className="font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl">
            Finanční poradenství
          </h1>
          <p className="mt-4 mb-4 max-w-xl text-base sm:text-lg md:text-xl lg:text-2xl">
            Osobní přístup ke každému klientovi
          </p>
          <button
            onClick={scrollToContact}
            className="bg-primary md:hover:bg-primary/90 mt-8 px-6 py-3 rounded-full font-medium text-sm sm:text-base md:text-lg transition"
          >
            Domluvte si konzultaci
          </button>
        </div>
      </div>
    </section>
  );
}
